/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsReceivedReviewIssueNewRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.received.review.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsReceivedReviewIssueNewRoute);
